import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.19048 7H3C1.89543 7 1 7.89543 1 9V13C1 14.1046 1.89543 15 3 15H9C10.1046 15 11 14.1046 11 13V11.5",
			stroke: "#39414D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 5.625V3.125L17.125 7.5L12.75 11.875V9.3125C9.625 9.3125 7.4375 10.3125 5.875 12.5C6.5 9.375 8.375 6.25 12.75 5.625Z",
			fill: "#39414D"
		})
	]
});
const ForwardRef = forwardRef(SvgExportIcon);
export { ForwardRef as ReactComponent };
